import { FilterBase } from './FilterBase';


export class FilterMesureType extends FilterBase {
        
    public umtIds:Array<number>
    public mesureUniteIds:Array<number>
    
    
    constructor({umtIds = [] as Array<number>,mesureUniteIds = [] as Array<number>,...args} = {}) { 
        super(args)       
        this.umtIds = umtIds
        this.mesureUniteIds = mesureUniteIds
    }
}
